window.shareProduct = function () {
    if (!customElements.get('share-button')) { // Check if already defined
        class ShareButton extends HTMLElement {
            constructor() {
                super();

                this.elements = {
                    shareButton: this.querySelector('.share-button__button'),
                    successMessage: this.querySelector('[id^="ShareMessage"]'),
                    urlInput: this.querySelector('input'),
                    content: this.querySelector('.share-button__fallback'),
                    copyButton: this.querySelector('.button-copy'),
                    closeButton: this.querySelector('.share-button__close')
                };

                this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
                this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
                this.elements.closeButton.addEventListener('click', this.closeDetails.bind(this));
                document.querySelector('.background-overlay')?.addEventListener('click', this.closeDetails.bind(this));
            }

            toggleDetails(event) {
                event.preventDefault();
                event.stopPropagation();

                // Get the current page URL dynamically
                const url = window.location.href;

                this.setProductInfoTop(this.getProductInfoPosition());

                this.elements.successMessage.classList.add('hidden');
                this.elements.urlInput.setAttribute('value', url); // Set current page URL
                this.elements.urlInput.setAttribute('data-url', url);
                this.elements.urlInput.classList.remove('is-copy');
                this.elements.content.classList.toggle('is-open');
                document.querySelector('body').classList.add('modal-share-open');
            }

            copyToClipboard(event) {
                event.preventDefault();
                event.stopPropagation();

                if (!this.elements.urlInput.classList.contains('is-copy')) {
                    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
                        this.elements.successMessage.setAttribute('aria-hidden', false);
                        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
                        this.elements.urlInput.classList.add('is-copy');
                       document.querySelector(".custom_wishlist .copied_msg").innerHTML = 'Link copied to clipboard!';


                        setTimeout(() => {
                            this.elements.successMessage.setAttribute('aria-hidden', true);
                            this.elements.urlInput.setAttribute('value', this.elements.urlInput.getAttribute('data-url')); // Reset back to URL
                           document.querySelector(".custom_wishlist .copied_msg").innerHTML = '';

                        }, 3000);
                    });
                }
            }

            closeDetails(event) {
                event.preventDefault();

                this.elements.successMessage.classList.add('hidden');
                this.elements.urlInput.setAttribute('value', this.elements.urlInput.getAttribute('data-url')); // Reset URL
                this.elements.urlInput.classList.remove('is-copy');
                this.elements.content.classList.remove('is-open');
                document.querySelector('body').classList.remove('modal-share-open');
                this.setProductInfoTop(0);
            }

            getProductInfoPosition() {
                const stickyElement = document.querySelector('.productView-details');
                if (!stickyElement) return 0;

                const parentElement = stickyElement.parentNode;
                const stickyRect = stickyElement.getBoundingClientRect();
                const parentRect = parentElement.getBoundingClientRect();

                return stickyRect.top - parentRect.top;
            }

            setProductInfoTop(top) {
                const productDetails = document.querySelector('.productView-details');
                if (productDetails) {
                    productDetails.style.setProperty('--sticky-top', `${top}px`);
                }
            }
        }

        customElements.define('share-button', ShareButton);
    }
};

// Initialize only when necessary
var shareShow = document.body.classList.contains('quick-view-show'),
    productShare = document.querySelectorAll('.halo-productView .productView-share').length;

if (document.body.classList.contains('template-product')) {
    if (!shareShow && productShare) {
        window.shareProduct();
    } else if (shareShow && productShare === 0) {
        window.shareProduct();
    }
} else {
    window.shareProduct();
}
